<main [dir]="selectedLanguage !== 'ar' ? 'ltr': 'rtl'">
  <router-outlet></router-outlet>
</main>
